<template>
  <div class="instrucciones-cobros-list">
    <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :fechaDesde="fechaDesdeParam"
          :fechaHasta="fechaHastaParam"
          :cliente="cliente"
          @filtrar="filtrar">
        </app-filtro>  
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card header="Registro de Instrucciones de Cobro">
          <b-table hover
              responsive="sm" 
              class="registro"
              :busy="tableBusy"
              :items="instruccionesCobros" 
              :fields="fields" 
              @row-clicked="consultar">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>              
            <template v-slot:cell(fechaRegistro)="data">
              {{ data.item.fechaRegistro | fecha }}
            </template>
            <template v-slot:cell(fechaComprobante)="data">
              {{ data.item.fechaComprobante | fecha }}
            </template>
            <template v-slot:cell(total)="data">
              {{ data.item.total | moneda(data.item.moneda) }}
            </template>
            <template v-slot:cell(opciones)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <!-- <b-dropdown-item @click.stop="exportPDF(data.item)">
                  <i class="fa fa-file-pdf-o"></i>Emitir Recibo</b-dropdown-item> -->
                <b-dropdown-item @click.stop="borrarItem(data.item)">
                  <i class="fa fa-remove"></i>Anular Instruccion de Cobro</b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="list-add-btn" @click.prevent="agregar">
          <i class="fa fa-plus fa-2x" aria-hidden="true"></i>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Filtro from './listFiltro.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs';
import moment from 'moment';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'instruccionesCobros/getField',
  mutationType: 'instruccionesCobros/updateField',
});

export default {
  name: 'InstruccionesCobrosList',
  components: {
    appFiltro: Filtro,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [
    // exportPDFReciboCliente,
    msjModal, 
    confirmModal,
  ],
  data: () => {
    return {
      fields: [
        { 
          key: 'id',
          label: 'Nro.Instrucción',
          // class: 'text-right'
        },
        { key: 'fechaRegistro' },
        { 
          key: 'fechaComprobante',
          label: 'Fecha Cobro'
        },
        { key: 'cliente' },
        { key: 'formaPago' },
        {
          key: 'total',
          class: 'text-right'
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      tableBusy: false,
    }
  },
  computed: {
    ...mapFields([
      'instruccionesCobros',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
      'fechaDesde',
      'fechaHasta',
      'cliente',
    ]),
    fechaDesdeParam() {
      return moment(this.fechaDesde).format('YYYY-MM-DD');
    },
    fechaHastaParam() {
      return moment(this.fechaHasta).format('YYYY-MM-DD');
    }
  },
  created() {
    this.getItems();
  },  
  methods: {
    filtrar(filtro) {
      this.fechaDesde = filtro.fechaDesde;
      this.fechaHasta = filtro.fechaHasta;
      this.cliente = filtro.cliente;
      this.paginaActual = 1;
      
      this.getItems();
    },
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('instruccionesCobros/getInstruccionesCobros')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },
    agregar () {
      this.$router.push({ name: 'InstruccionCobroABM' });
    },
    consultar (item) {
      this.$router.push({ name: 'InstruccionCobroData', 
                          params: { id: item.id }});
    },
    borrarItem (item) {
      this.showModalConfirm('¿Desea anular la instrucción de cobro seleccionada?', 
            this.borrar.bind(this, item.id), 'Si', null, 'No')
    },
    borrar (instruccionCobroId) {
      this.showSpinner();
      this.$store.dispatch('instruccionesCobros/delete', instruccionCobroId)
        .then(() => this.showModalMsj('La instrucción de cobro se anuló con éxito.', this.getItems, this.getItems, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    // exportPDF(item) {
    //   let empresa = {};
    //   this.$store.dispatch('empresa/inicializar')
    //     .then(() => {
    //       empresa = this.$store.getters['empresa/empresa'];
    //       return;
    //     })
    //     .then(() => {
    //       return this.$store.dispatch('cobro/getDatos', item.id)
    //     })
    //     .then(() => {
    //       this.exportPDFReciboCliente(this.$store.getters['cobro/cobroDatosRpt'], empresa);
    //     })
    //     .catch(error => this.showErrorMsj(error));
    // },
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems();
      }
    },    
  }    
}
</script>

<style>
  .instrucciones-cobros-list .registro table td[aria-colindex="1"] {
    width: 10%;
  }
  .instrucciones-cobros-list .registro table td[aria-colindex="2"] {
    width: 10%;
  }
  .instrucciones-cobros-list .registro table td[aria-colindex="3"] {
    width: 10%;
  }
  .instrucciones-cobros-list .registro table td[aria-colindex="4"] {
    width: calc(35% - 60px);
  }
  .instrucciones-cobros-list .registro table td[aria-colindex="5"] {
    width: 20%;
  }
  .instrucciones-cobros-list .registro table td[aria-colindex="6"] {
    width: 15%;
  }
  .instrucciones-cobros-list .registro table td[aria-colindex="7"] {
    width: 60px;
  }

</style>
